module.exports = __webpack_public_path__ + "./fonts/DMSans-Regular.116ebf.woff";